/** tray shape ids */
export enum TrayShapeId {
    TraysSquare = 'traysSquare',
    TrayRectangle = 'trayRectangle',
    TrayRound = 'trayRound',
    TrayOval = 'trayOval',
    TrayArc = 'trayArc',
    TrayHexagonal = 'trayHexagonal',
    TrayTriangle = 'trayTriangle',
    Hexagonal = 'hexagonal',
    ReturnLeft = 'returnLeft',
    ReturnRight = 'returnRight',
    SingleShape = 'singleShape',
    LShape = 'lShape',
    UShape = 'uShape',
}

/** trayVolume shape ids */
export enum TrayVolumeShapeId {
    TraysVolumeSquare = 'traysVolumeSquare',
    TrayVolumeRectangle = 'trayVolumeRectangle',
    TrayVolumeRound = 'trayVolumeRound',
    TrayVolumeOval = 'trayVolumeOval',
    TrayVolumeHexagonal = 'trayVolumeHexagonal',
    TrayVolumeTriangle = 'trayVolumeTriangle',
}

/** legs shape ids */
export enum LegsShapeId {
    LegsAdventurer = 'legsAdventurer',
    LegsClassic = 'legsClassic',
    LegsCross = 'legsCross',
    LegsGreedy = 'legsGreedy',
    LegsHairPin = 'legsHairPin',
    LegsHarmonious = 'legsHarmonious',
    LegsMalicious = 'legsMalicious',
    LegsMikado = 'legsMikado',
    LegsMonastery = 'legsMonastery',
    LegsRider = 'legsRider',
    LegsRightCrossPiece = 'legsRightCrossPiece',
    LegsOther = 'legsOther',
    LegsRoundLegs = 'legsRoundLegs',
    LegsScandinavian = 'legsScandinavian',
    LegsSquare = 'legsSquare',
    LegsSquareCrossPiece = 'legsSquareCrossPiece',
    LegsTrapeze = 'legsTrapeze',
    LegsTrapezeInverted = 'legsTrapezeInverted',
    LegsTrapezeCentral = 'legsTrapezeCentral',
    LegsTrestleCross = 'legsTrestleCross',
    LegsUShaped = 'legsUShaped',
    LegsUShapedStrengthened = 'legsUShapedStrengthened',
    LegsVShaped = 'legsVShaped',
    LegsVShapedCentral = 'legsVShapedCentral',
    TvSquareLegs = 'tvSquareLegs',
    TvRoundLegs = 'tvRoundLegs',
    TvULegs = 'tvULegs',
    TvNoLegs = 'tvNoLegs',
}

/** border shape ids */
export enum BorderShapeId {
    SquareStraightEdge = 'squareStraightEdge',
    LiveEdge = 'liveEdge',
    StraightEdgeChamfer = 'straightEdgeChamfer',
    StraightEdgeSoftened = 'straightEdgeSoftened',
    RoundedQuarterCircle = 'roundedQuarterCircle',
    RoundedHalfCircle = 'roundedHalfCircle',
    AirplaneWings = 'airplaneWings',
}

/** extension shape ids */
export enum ExtensionShapeId {
    OffsetExtension = 'offsetExtension',
    CentralExtension = 'centralExtension',
    ButterflyExtension = 'butterflyExtension',
    SideExtension = 'sideExtension',
}

/** connectics shape ids */
export enum ConnecticShapeId {
    ELEConnector = 'eleConnector',
    HDMIConnector = 'hdmiConnector',
    USBConnector = 'usbConnector',
    ETHERNETConnector = 'ethernetConnector',
    CableGland = 'cableGland',
}

/** storage shape ids */
export enum StorageShapeId {
    SimpleDrawer = 'simpleDrawer',
    SlidingShelf = 'slidingShelf',
    StorageBox = 'storageBox',
}

/** Library shape ids */
export enum LibraryShapeId {
    Niche = 'niche',
    NicheMedium = 'nicheMedium',
    NicheLarge = 'nicheLarge',
    Door = 'door',
    Drawer = 'drawer',
    Shelf = 'shelf',
}

/** cutting shape ids  */
export enum CuttingShapeId {
    IntegratedSink = 'integratedSink',
    Drainer = 'drainer',
    IntegratedAppliance = 'integratedAppliance',
}

/** opening shape ids */
export enum OpeningShapeId {
    MagnetClosure = 'magnetClosure',
    CremoneClosure = 'cremoneClosure',
    SingleDoor = 'singleDoor',
    DoubleDoor = 'doubleDoor',
    DoubleSwingDoors = 'doubleSwingDoors',
    SlidingDoors = 'slidingDoors',
}

/** wardrobe shape ids */
export enum WardrobeShapeId {
    BarHangerCloth = 'barHangerCloth',
    BeltHanger = 'beltHanger',
    DrawerCase = 'drawerCase',
    PantsHanger = 'pantsHanger',
    ShoesDrawer = 'shoesDrawer',
    TelescopicHangerCloth = 'telescopicHangerCloth',
    TieHanger = 'tieHanger',
    WardrobeLight = 'wardrobeLight',
}

/** closetDoor shape ids */
export enum ClosetDoorShapeId {
    ClosetNormal = 'closetNormal',
    ClosetSlopeLeft = 'closetSlopeLeft',
    ClosetSlopeRight = 'closetSlopeRight',
    ClosetFolding = 'closetFolding',
    ClosetSliding = 'closetSliding',
    ClosetSwing = 'closetSwing',
    ClosetHandle = 'closetHandle',
    ClosetLock = 'closetLock',
}

/** windows shape ids */
export enum WindowShapeId {
    SingleWindow = 'singleWindow',
    DoubleWindow = 'doubleWindow',
    DoubleWindowDoor = 'doubleWindowDoor',
    SimpleWindowDoor = 'simpleWindowDoor',
    SlidingWindow = 'slidingWindow',
    SlidingWindowDoor = 'slidingWindowDoor',
    WindowBay = 'windowBay',
    WindowCorner = 'windowCorner',
    WindowDiamond = 'windowDiamond',
    WindowElbow = 'windowElbow',
    WindowLowered = 'windowLowered',
    WindowPointedTrapezoidal = 'windowPointedTrapezoidal',
    WindowRound = 'windowRound',
    WindowSemicircular = 'windowSemicircular',
    WindowTrapezoidal = 'windowTrapezoidal',
    WindowTrapezoidalWithShell = 'windowTrapezoidalWithShell',
    WindowTriangle = 'windowTriangle',
}

/** mirror shape ids */
export enum MirrorShapeId {
    RoundMirror = 'roundMirror',
    OvalMirror = 'ovalMirror',
    RectangleMirror = 'rectangleMirror',
    SquareMirror = 'squareMirror',
}

/** showerScreen shapeids */
export enum ShowerScreenShapeId {
    DoubleShowerScreen = 'doubleShowerScreen',
    SimpleShowerScreen = 'simpleShowerScreen',
}

/** highWind shape ids */
export enum HighWindShapeId {
    SimpleHighWind = 'simpleHighWind',
    HalfCircleHighWind = 'halfCircleHighWind',
    RoundedHighWind = 'roundedHighWind',
}

/** highWind destination ids */
export enum HighWindDestinationShapeId {
    HighWindWindow = 'highWindWindow',
    HighWindDoor = 'highWindDoor',
}

/** veranda shape ids */
export enum VerandaShapeId {
    SquareShape = 'squareShape',
    RectangleShape = 'rectangleShape',
    LShape = 'lShape',
    UShape = 'uShape',
    TShape = 'tShape',
    DoubleRoofVeranda = 'doubleRoofVeranda',
    FlatRoofVeranda = 'flatRoofVeranda',
    SlopingRoofVeranda = 'slopingRoofVeranda',
    VerandaHeater = 'verandaHeater',
    VerandaStore = 'verandaStore',
    VerandaBurglarProofGlazing = 'verandaBurglarProofGlazing',
    VearndaLighting = 'vearndaLighting',
    VearndaThermalInsulation = 'vearndaThermalInsulation',
}

/** tvUnitStorage shape ids */
export enum TvUnitStorageShapeId {
    TvNiche = 'tvNiche',
    TvDrawer = 'tvDrawer',
    TvDoor = 'tvDoor',
}

/** glassWall elements shape ids */
export enum GlassWallShapeId {
    DoubleDoorGlassWall = 'doubleDoorGlassWall',
    DoubleWindowsGlassWall = 'doubleWindowsGlassWall',
    SimpleDoorGlassWall = 'simpleDoorGlassWall',
    SimpleWindowsGlassWall = 'simpleWindowsGlassWall',
    SlidingDoorGlassWall = 'slidingDoorGlassWall',
    TraverseHorizontalGlassWall = 'traverseHorizontalGlassWall',
    TraverseVerticalGlassWall = 'traverseVerticalGlassWall',
    TraverseCrossedGlassWall = 'traverseCrossedGlassWall',
}

/** obstacle elements shape ids */
export enum StaircaseObstacleShapeId {
    Radiator = 'radiator',
}

/** landing element shape ids */
export enum StaircaseLandingShapeId {
    StaircaseQuarterTurnDown = 'staircaseQuarterTurnDown',
    StaircaseQuarterTurnHigh = 'staircaseQuarterTurnHigh',
    StaircaseQuarterTurnMiddle = 'staircaseQuarterTurnMiddle',
}

/** railing elemnt shape ids */
export enum StairecaseRailingShapeId {
    StaircaseRailing = 'staircaseRailing',
}

/** turn element shape ids */
export enum StaircaseTurnShapeId {
    StaircaseQuarterTurnLeft = 'staircaseQuarterTurnLeft',
    StaircaseQuarterTurnRight = 'staircaseQuarterTurnRight',
}

/** option element shape ids */
export enum StaircaseOptionShapeId {
    LightedSteps = 'lightedSteps',
    LightRamp = 'lightRamp',
    IntegratedStorage = 'integratedStorage',
}

/** riser element shape ids */
export enum StaircaseRiserShapeId {
    StaircaseWithoutRisers = 'staircaseWithoutRisers',
    StaircaseWithRisers = 'staircaseWithRisers',
}

/** limon element shape ids */
export enum StaircaseLimonShapeId {
    CentralLimon = 'centralLimon',
    LateralLimon = 'lateralLimon',
}

/** deck board element shape ids */
export enum TerraceShapeId {
    DeckBoardGroove = 'deckBoardGroove',
    DeckBoardSmooth = 'deckBoardSmooth',
    DeckBoardVein = 'deckBoardVein',
    LTerraceShape = 'lTerraceShape',
    RectangleTerraceShape = 'rectangleTerraceShape',
    RoundTerraceShape = 'roundTerraceShape',
    SquareTerraceShape = 'squareTerraceShape',
    TTerraceShape = 'tTerraceShape',
    UTerraceShape = 'uTerraceShape',
}

/** pose element shape ids */
export enum WineCellarPoseId {
    WineCellarBuiltIn = 'wineCellarBuiltIn',
    WineCellarFreeStanding = 'wineCellarFreeStanding',
}

/** room element shape ids */
export enum WineCellarRoomId {
    WineCellarCellar = 'wineCellarCellar',
    WineCellarGarage = 'wineCellarGarage',
    WineCellarOutside = 'wineCellarOutside',
    WineCellarOther = 'wineCellarOther',
}

/** roomShape element shape ids */
export enum WineCellarShapeId {
    WineCellarStraight = 'wineCellarStraight',
    WineCellarUShape = 'wineCellarUShape',
    WineCellarLShape = 'wineCellarLShape',
}

/** door element shape ids */
export enum WineCellarDoorId {
    WineCellarFullDoor = 'wineCellarFullDoor',
    WineCellarGlassDoor = 'wineCellarGlassDoor',
}

export enum WineCellarNbDoorId {
    WineCellarDoorQuantity = 'wineCellarDoorQuantity',
}

/** door sens element shape ids */
export enum WineCellarSensDoorId {
    WineCellarDoorOpenLeft = 'wineCellarDoorOpenLeft',
    WineCellarDoorOpenRight = 'wineCellarDoorOpenRight',
}

/** option element shape ids */
export enum WineCellarOptionId {
    WineCellarTempPanel = 'wineCellarTempPanel',
    WineCellarLighting = 'wineCellarLighting',
    WineCellarLock = 'wineCellarLock',
}

/** shelf element shape ids */
export enum WineCellarShelfId {
    WineCellarPresentationShelf = 'wineCellarPresentationShelf',
    WineCellarSlidingShelf = 'wineCellarSlidingShelf',
    WineCellarStorageShelf = 'wineCellarStorageShelf',
    WineCellarStorageSpace = 'wineCellarStorageSpace',
}

/** number of bottles element shape ids */
export enum WineCellarNbBottleId {
    WineCellarNbBottle = 'wineCellarNbBottle',
}

/** fence destination element shape ids */
export enum FenceDestinationId {
    FenceWindow = 'fenceWindow',
    FenceTerrace = 'fenceTerrace',
    FenceStaircase = 'fenceStaircase',
    FenceMezzanine = 'fenceMezzanine',
}

/** fence poles element shape ids */
export enum FencePolesId {
    FenceRoundPoles = 'fenceRoundPoles',
    FenceSquarePoles = 'fenceSquarePoles',
}

/** fence filling element shape ids */
export enum FenceFillingId {
    FenceFillingUniform = 'fenceFillingUniform',
    FenceFillingSimpleSmooth = 'fenceFillingSimpleSmooth',
    FenceFillingDoubleSmooth = 'fenceFillingDoubleSmooth',
}

/** pergola element shape ids */
export enum PergolaShapeId {
    PergolaLeaned = 'pergolaLeaned',
    PergolaSelfSupporting = 'pergolaSelfSupporting',
}

/** pergola options shape ids */
export enum PergolaOptionsId {
    PergolaLighting = 'pergolaLighting',
    PergolaHeater = 'pergolaHeater',
    PergolaStore = 'pergolaStore',
}

/** windowLeafeaf element shape ids */
export enum WindowLeafShapeId {
    WindowOneLeaf = 'windowOneLeaf',
    WindowTwoLeaf = 'windowTwoLeaf',
    WindowThreeLeaf = 'windowThreeLeaf',
}

/** opening element shape ids */
export enum GarageDoorOpeningId {
    RoolUpDoor = 'roolUpDoor',
    SectionalDoor = 'sectionalDoor',
    SlidingDoor = 'slidingDoor',
    SwingDoor = 'swingDoor',
    TiltingDoor = 'tiltingDoor',
}

/** groove element shape ids */
export enum GarageDoorGrooveId {
    Horizontal = 'horizontal',
    Vertical = 'vertical',
    Molding = 'molding',
}

/** claustra destination shape ids */
export enum ClaustraDestinationId {
    ClaustraIndoor = 'claustraIndoor',
    ClaustraOutdoor = 'claustraOutdoor',
}

/** claustra mobility shape ids */
export enum ClaustraMobilityId {
    ClaustraFixed = 'claustraFixed',
    ClaustraMobile = 'claustraMobile',
    ClaustraSemiMobile = 'claustraSemiMobile',
}

/** claustra type shape ids */
export enum ClaustraTypeId {
    ClaustraOpenWork = 'claustraOpenWork',
    ClaustraSolid = 'claustraSolid',
}

/** beds type shape ids */
export enum BedsTypeId {
    BedSingle = 'bedSingle',
    BedDouble = 'bedDouble',
    MezzanineSingle = 'mezzanineSingle',
    MezzanineDouble = 'mezzanineDouble',
    BedRound = 'bedRound',
    BedCasters = 'bedCasters',
    BedHead = 'bedHead',
    BedSafe = 'bedSafe',
    BedStorage = 'bedStorage',
    BedLighting = 'bedLighting',
    OfficeUnderMezzanine = 'officeUnderMezzanine',
    StorageUnderMezzanine = 'storageUnderMezzanine',
    FrameRound = 'frameRound',
    FrameSquare = 'frameSquare',
    FrameRectangle = 'frameRectangle',
}

/** vegetalWall type shape ids */
export enum VegetalWallId {
    VegetalWallArtificial = 'vegetalWallArtificial',
    VegetalWallIndoor = 'vegetalWallIndoor',
    VegetalWallLighting = 'vegetalWallLighting',
    VegetalWallLogo = 'vegetalWallLogo',
    VegetalWallNatural = 'vegetalWallNatural',
    VegetalWallOutdoor = 'vegetalWallOutdoor',
    VegetalWallStabilized = 'vegetalWallStabilized',
}

export enum VegetalWallOptionId {
    VegetalWallFern = 'vegetalWallFern',
    VegetalWallFoamBall = 'vegetalWallFoamBall',
    VegetalWallFoamLichen = 'vegetalWallFoamLichen',
    VegetalWallIvy = 'vegetalWallIvy',
    VegetalWallLushNature = 'vegetalWallLushNature',
    VegetalWallPhilodendron = 'vegetalWallPhilodendron',
}

export enum WindowBlindsId {
    WindowBlindsBoat = 'windowBlindsBoat',
    WindowBlindsCalifornian = 'windowBlindsCalifornian',
    WindowBlindsJapanese = 'windowBlindsJapanese',
    WindowBlindsPleated = 'windowBlindsPleated',
    WindowBlindsVelux = 'windowBlindsVelux',
    WindowBlindsVenetian = 'windowBlindsVenetian',
    WindowBlindsWinder = 'windowBlindsWinder',
    WindowBlindsBlackout = 'windowBlindsBlackout',
    WindowBlindsDayNight = 'windowBlindsDayNight',
    WindowBlindsSifting = 'windowBlindsSifting',
    WindowBlindsBalcony = 'windowBlindsBalcony',
    WindowBlindsTerrace = 'windowBlindsTerrace',
    WindowBlindsWindow = 'windowBlindsWindow',
    WindowBlindsFlat = 'windowBlindsFlat',
    WindowBlindsHouse = 'windowBlindsHouse',
    WindowBlindsAwing = 'windowBlindsAwing',
    WindowBlindsAwingProjection = 'windowBlindsAwingProjection',
    WindowBlindsDoubleAwing = 'windowBlindsDoubleAwing',
}

/** shoesCabinet shape ids */
export enum ShoesCabinetId {
    ShoesStorageBattants = 'shoesStorageBattants',
    ShoesStorageClassic = 'shoesStorageClassic',
    ShoesDrawer = 'shoesDrawer',
    ShoesQuantity = 'shoesQuantity',
    ShoesLocker = 'shoesLocker',
};

/** lowTable shape ids */
export enum LowTableId {
    LowTableDoubleTray = 'lowTableDoubleTray',
    LowTableDrawer = 'lowTableDrawer',
    LowTableLed = 'lowTableLed',
    LowTableLiftableTray = 'lowTableLiftableTray',
    LowTableOpenStorage = 'lowTableOpenStorage',
    LowTableSlidingStorage = 'lowTableSlidingStorage',
    LowTableDocumentHolder = 'lowTableDocumentHolder',
};

/** fencing type shape ids */
export enum FencingTypeId {
    FencingOpenWork = 'fencingOpenWork',
    FencingSolid = 'fencingSolid',
    FencingOther = 'fencingOther',
}

/** portal shape ids */
export enum PortalTypeId {
    PortalConcave = 'portalConcave',
    PortalConvex = 'portalConvex',
    PortalDiagonalHight = 'portalDiagonalHight',
    PortalDiagonalLow = 'portalDiagonalLow',
    PortalPolicemanHat = 'portalPolicemanHat',
    PortalPolicemanHatInverted = 'portalPolicemanHatInverted',
    PortalStraight = 'portalStraight',
}

/** portal options ids */
export enum PortalOptionsId {
    PortalIntercom = 'portalIntercom',
    PortalVideophone = 'portalVideophone',
    PortalLighting = 'portalLighting',
}

/** portal leaves ids */
export enum PortalLeavesId {
    PortalOneLeave = 'portalOneLeave',
    PortalTowLeave = 'portalTowLeave',
}

/** portal opening ids */
export enum PortalOpeningId {
    PortalOpeningSlide = 'portalOpeningSlide',
    PortalOpeningSwing = 'portalOpeningSwing',
}

/** portal style ids */
export enum PortalStyleId {
    PortalOpenWork = 'portalOpenWork',
    PortalSolid = 'portalSolid',
}

/** kitchen home apliance ids */
export enum KitchenHomeApplianceOptionId {
    KitchenBakingTray = 'kitchenBakingTray',
    kitchenColumn = 'kitchenColumn',
    kitchenCook = 'kitchenCook',
    KitchenDishwasher = 'kitchenDishwasher',
    KitchenFridge = 'kitchenFridge',
    KitchenHood = 'kitchenHood',
    KitchenLowFurniture = 'kitchenLowFurniture',
    KitchenMicroWave = 'kitchenMicroWave',
    KitchenOven = 'kitchenOven',
    KitchenSink = 'kitchenSink',
    KitchenTallFurniture = 'kitchenTallFurniture',
    kitchenWineCellar = 'kitchenWineCellar',
}

/** kitchen furniture option ids */
export enum KitchenFurnitureOptionId {
    kitchenColumn = 'kitchenColumn',
    KitchenLowFurniture = 'kitchenLowFurniture',
    KitchenTallFurniture = 'kitchenTallFurniture',
}

/** kitchen handle ids */
export enum KitchenHandleId {
    ClassicHandle = 'classicHandle',
    FacadeIntegratedhandle = 'facadeIntegratedhandle',
    FlatAndBevelGroove = 'flatAndBevelGroove',
    HandleOnEdge = 'handleOnEdge',
    PushPullHandle = 'pushPullHandle',
    WithoutHandlesWithThroat = 'withoutHandlesWithThroat',
}

/** kitchen shape ids */
export enum KitchenShapeId {
    RectangleRoom = 'rectangleRoom',
    SquareRoom = 'squareRoom',
    LRoom = 'lRoom',
    DiagonalRoom = 'diagonalRoom',
}

/** kitchen layout ids */
export enum KitchenLayoutId {
    LayoutIsland = 'layoutIsland',
    LayoutL = 'layoutL',
    LayoutParallel = 'layoutParallel',
    LayoutStraight = 'layoutStraight',
    LayoutU = 'layoutU',
}

/** kitchen style ids */
export enum KitchenStyleId {
    KitchenArtDeco = 'kitchenArtDeco',
    KitchenFullBlack = 'kitchenFullBlack',
    KitchenIndustrialLoft = 'kitchenIndustrialLoft',
    KitchenJapandi = 'kitchenJapandi',
    KitchenPastel = 'kitchenPastel',
    KitchenRural = 'kitchenRural',
    KitchenRusticChic = 'kitchenRusticChic',
    KitchenRusticModern = 'kitchenRusticModern',
    KitchenStrikingMarble = 'kitchenStrikingMarble',
    KitchenTerracotta = 'kitchenTerracotta',
    KitchenTerrazzo = 'kitchenTerrazzo',
    KitchenVegetated = 'kitchenVegetated',
    KitchenIndustrial = 'kitchenIndustrial',
    KitchenMinimalist = 'kitchenMinimalist',
    KitchenModern = 'kitchenModern',
    KitchenNatural = 'kitchenNatural',
    KitchenScandinavian = 'kitchenScandinavian',
    KitchenTraditional = 'kitchenTraditional',
}

/** kitchen shade ids */
export enum KitchenShadeSelectorId {
    ShadeTexture = 'shadeTexture',
    ShadePattern = 'shadePattern',
    ShadeWoodEffect = 'shadeWoodEffect',
    ShadeStoneEffect = 'shadeStoneEffect',
    ShadeConcreteEffect = 'shadeConcreteEffect',
    ShadeMarbleEffect = 'shadeMarbleEffect',
    ShadeUltraMattEffect = 'shadeUltraMattEffect',
    ShadeGraniteEffect = 'shadeGraniteEffect',
    ShadeQuartzEffect = 'shadeQuartzEffect',
    ShadeCeramicEffect = 'shadeCeramicEffect',
    ShadeTerrazzoEffect = 'shadeTerrazzoEffect',
}

export type AddOnShapeId =
    | KitchenHomeApplianceOptionId
    | LibraryShapeId
    | LowTableId
    | PortalOptionsId
    | StorageShapeId
    | TvUnitStorageShapeId
    | VegetalWallOptionId
    | WardrobeShapeId;

export type ShapeId =
    | BedsTypeId
    | BorderShapeId
    | ClaustraDestinationId
    | ClaustraMobilityId
    | ClaustraTypeId
    | ClosetDoorShapeId
    | ConnecticShapeId
    | CuttingShapeId
    | ExtensionShapeId
    | FenceDestinationId
    | FenceFillingId
    | FencePolesId
    | FencingTypeId
    | GarageDoorGrooveId
    | GarageDoorOpeningId
    | GlassWallShapeId
    | HighWindShapeId
    | HighWindDestinationShapeId
    | KitchenFurnitureOptionId
    | KitchenHandleId
    | KitchenHomeApplianceOptionId
    | KitchenLayoutId
    | KitchenShapeId
    | KitchenStyleId
    | KitchenShadeSelectorId
    | LegsShapeId
    | LibraryShapeId
    | LowTableId
    | MirrorShapeId
    | OpeningShapeId
    | PortalOpeningId
    | PergolaOptionsId
    | PergolaShapeId
    | PortalStyleId
    | PortalLeavesId
    | PortalOptionsId
    | PortalTypeId
    | ShoesCabinetId
    | ShowerScreenShapeId
    | StaircaseLandingShapeId
    | StaircaseLimonShapeId
    | StaircaseObstacleShapeId
    | StaircaseOptionShapeId
    | StaircaseRiserShapeId
    | StaircaseTurnShapeId
    | StairecaseRailingShapeId
    | StorageShapeId
    | TerraceShapeId
    | TrayVolumeShapeId
    | TrayShapeId
    | TvUnitStorageShapeId
    | VegetalWallOptionId
    | VegetalWallId
    | VerandaShapeId
    | WardrobeShapeId
    | WindowBlindsId
    | WindowShapeId
    | WindowLeafShapeId
    | WineCellarDoorId
    | WineCellarNbBottleId
    | WineCellarNbDoorId
    | WineCellarOptionId
    | WineCellarPoseId
    | WineCellarRoomId
    | WineCellarSensDoorId
    | WineCellarShapeId
    | WineCellarShelfId;
